



import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class PhoneFieldView extends Vue {
  @Prop({ type: String, default: '' }) value !: string
}
